import * as React from 'react';
import { Workbox } from 'workbox-window';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
const SERVICE_WORKER_PATH = '/service-worker.js';
const useStyles = makeStyles((theme) => ({
    alertTitle: {
        fontWeight: theme.font.weight.bold,
        color: theme.color.background.light,
    },
}));
export const ServiceWorkerListener = ({ history, enabled }) => {
    const classes = useStyles();
    const { t } = useTranslation('common');
    const [navigated, setNavigated] = React.useState(false);
    const [registration, setRegistration] = React.useState(null);
    const [waitingUpdate, setWaitingUpdate] = React.useState(null);
    React.useEffect(() => {
        return history.listen(() => {
            setNavigated(true);
            if (registration) {
                console.log('[SWM] checking update');
                registration.update();
            }
        });
    }, [history, registration]);
    React.useEffect(() => {
        if (!enabled) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (let registration of registrations) {
                    registration.unregister();
                }
            });
            return;
        }
        if (!registration) {
            if ('serviceWorker' in navigator) {
                console.log('[SWM] Registering...');
                new Workbox(SERVICE_WORKER_PATH).register().then((registration) => {
                    console.log('[SWM] Registered: ', registration);
                    if (!registration) {
                        return;
                    }
                    setRegistration(registration);
                });
            }
            else {
                console.log('[SWM] Not supported');
            }
        }
    }, []);
    React.useEffect(() => {
        if (!enabled || !registration)
            return;
        const onUpdateFound = (event) => {
            console.log('[SWM] Update found', event);
            const installing = registration.installing;
            if (installing) {
                installing.addEventListener('statechange', () => {
                    console.log('[SWM] State change', event);
                    if (registration.waiting) {
                        console.log('[SWM] New service worker waiting');
                        if (navigator.serviceWorker.controller) {
                            if (navigated) {
                                setWaitingUpdate(registration.waiting);
                            }
                            else {
                                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                            }
                        }
                        else {
                            console.log('[SWM] Initialized for the first time');
                        }
                    }
                    if (installing == registration.active) {
                        console.log('[SWM] Update installed');
                        setWaitingUpdate(null);
                    }
                });
            }
        };
        registration.addEventListener('updatefound', onUpdateFound);
        return () => registration.removeEventListener('updatefound', onUpdateFound);
    }, [registration, navigated]);
    React.useEffect(() => {
        if ('serviceWorker' in navigator) {
            let isControlled = Boolean(navigator.serviceWorker.controller);
            console.log('[SWM] Controller', navigator.serviceWorker.controller);
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                console.log('[SWM] Controller change');
                if (isControlled) {
                    window.location.reload();
                }
                else {
                    isControlled = true;
                }
            });
        }
    }, []);
    if (!waitingUpdate)
        return null;
    const handleClose = () => setWaitingUpdate(null);
    const skipWaiting = () => waitingUpdate.postMessage({ type: 'SKIP_WAITING' });
    const message = t('common:update_available');
    return (React.createElement(Snackbar, { open: true, anchorOrigin: { vertical: 'top', horizontal: 'center' } },
        React.createElement(Alert, { severity: 'info', elevation: 6, variant: "filled", action: React.createElement(React.Fragment, null,
                React.createElement(Button, { color: "inherit", size: "small", onClick: skipWaiting }, t('common:update')),
                React.createElement(Button, { color: "inherit", size: "small", onClick: handleClose }, t('common:update_later'))) },
            React.createElement(AlertTitle, { classes: { root: classes.alertTitle } }, message))));
};
//# sourceMappingURL=ServiceWorkerListener.js.map